import React from 'react';
import {Box, type SxProps, useTheme} from '@mui/material';
import Typography from '@mui/material/Typography';

type Props = {
  code?: string;
  // showAll: false will show ellipes behind the text if too long
  // showAll: true  will show all text, but break to newline on every character.
  showAll?: boolean;
};

export const ThesaurusNodeCode: React.FC<Props> = ({code, showAll}) => {
  const {palette, spacing} = useTheme();

  const sx = {
    padding: spacing(0.5, 1),
    color: palette.primary.main,
  };

  const textModeSx: SxProps = showAll
    ? {
        maxWidth: '100px',
        wordBreak: 'break-all',
      }
    : {
        maxWidth: '100px',
        overflow: 'hidden',
        textWrap: 'nowrap',
        textOverflow: 'ellipsis',
      };

  if (!code) {
    return null;
  }

  return (
    <Box
      sx={{
        margin: spacing(0.5, 1, 0.5, 0),
        borderRadius: spacing(1),
        backgroundColor: palette.background.default,
      }}>
      <Typography
        variant="subtitle1"
        sx={{
          ...sx,
          ...textModeSx,
        }}>
        {code}
      </Typography>
    </Box>
  );
};
